module.exports = __webpack_public_path__ + "img/vehicle-options-white-cjdr.9c0e7bfc.jpg";